<template>
<div class="min-h-screen bg-gray-50 flex flex-col pt-20 md:pt-64 py-12 px-8 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <logo  variant="logo-small" class="mx-auto w-12"/>

      <h2 class="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900">
        Unlock the power of vector
      </h2>
      <p class="mt-2 text-center text-sm leading-5 text-gray-600 max-w">
        Or
        <router-link :to="{ name: 'Login', query: { ...this.$route.query } }" class="font-medium text-primary hover:text-primary-400 focus:outline-none focus:underline transition ease-in-out duration-150">
          login to your existing account
        </router-link>
      </p>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow rounded-lg sm:px-10">
        <form @submit.prevent="signUpWithEmail">
          <div>
            <label for="email" class="block text-sm font-medium leading-5 text-gray-600">
              Email address
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <base-input v-model.trim="email" id="email" type="email" placeholder="hello@hey.com" required/>
            </div>
          </div>

          <div class="mt-6">
            <label for="password" class="block text-sm font-medium leading-5 text-gray-600">
              Password
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <base-input v-model="password" id="password" type="password" required/>
            </div>
          </div>

          <div class="mt-6">
            <label for="password" class="block text-sm font-medium leading-5 text-gray-600">
              Confirm Password
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <base-input v-model="confirmPassword" id="confirmPassword" type="password" required/>
            </div>
          </div>

          <p v-show="errorMessage" class="text-red-500 mt-6 text-sm">{{ errorMessage }}</p>

          <div class="mt-6">
            <span class="block w-full rounded-md shadow-sm">
              <base-button type="submit" class="w-full justify-center">
                Get Started
              </base-button>
            </span>
          </div>
        </form>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "SignUpPage",
  metaInfo: {
      title: 'Sign Up',
  },
  data() {
    return {
      email: "",
      password: "",
      confirmPassword: "",
      errorMessage: null,
    };
  },
  methods: {
    async signUpWithEmail() {
      this.$root.$emit('loading', true);
      this.errorMessage = null;
      try {
        await this.validateForm();
        await this.$auth.createUserWithEmailAndPassword(
          this.email,
          this.password
        );
        await this.$auth.signInWithEmailAndPassword(this.email, this.password);

      } catch (error) {
        this.errorMessage = error.message;
      }

      this.$root.$emit('loading', false);
    },
    async validateForm() {
      const password = this.password;

      if (password.length < 6) {
        throw Error("Password isn't long enough (minimum 6 characters).");
      }

      if (password !== this.confirmPassword) {
        throw Error("Password must match the confirm password.");
      }

      return true;
    },
  },
};
</script>
